import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDetails } from '../../models/userDetails';
import axios from 'axios';
import { getToken, getUserDetails } from '../../utilities/sessionHelper';
import { composeParamsString } from '../../utilities/CommonHelper';

interface PendingUserData {
    id: number;
    type: string;
    employeeName: string;
    employeeEmail: string;
    employeeId: string;
    businessUnit: string;
    department: string;
    reportingManagerName: string;
    reportingManagerEmail: string;
    role: string;
    accessReason: string;
    reminderEmailCount: number;
    requestStatus: string;
    approvalRejects: any[];
  }

  interface ActiveUserData {
    createdBy: string;
    createdDate: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    id: string;
    email: string;
    name: string;
    businessUnit: string;
    department: string;
    reportingManagerName: string;
    reportingManagerEmail: string;
    employeeStatus: string;
    accessStatus: string;
  }

  interface InactiveUserData {
    createdBy: string;
    createdDate: string;
    lastModifiedBy: string;
    lastModifiedDate: string;
    id: string;
    email: string;
    name: string;
    businessUnit: string;
    department: string;
    reportingManagerName: string;
    reportingManagerEmail: string;
    employeeStatus: string;
    accessStatus: string;
  }
  
  interface EmployeeResponse {
    pendingUserData: PendingUserData[] | null;
    activeUserList: ActiveUserData[] | null;
    inactiveUserList:InactiveUserData[] |null;
    auditloglist:   any[] | null;
    error: null | string;
    loading: boolean;
  }

  const initialState: EmployeeResponse = {
    pendingUserData: null,
    activeUserList:null,
    inactiveUserList:null,
    auditloglist:null,
    error: null,
    loading: false,  
};

export const fetchPendingRequestbyAdmin:any = createAsyncThunk(
  'request/fetchPendingRequestbyAdmin',
  async (params:{
    page?: number;
    size?: number;
    sort?: string[];
  },{rejectWithValue}) => {
    try {
        const axiosConfig = {
        headers: {
          'Authorization' : 'Bearer '+getToken(),
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'ananda.rao@indegene.com'
        },
        withCredentials: true
      };
      let paramStrings: string | null = composeParamsString(params);
      // Simulate an API call, replace with your actual API request
      const response = await axios.get(`user/request/pendingRequestAtAdmin?${paramStrings}`,axiosConfig);
      console.log('request/pendingRequestAtAdmin',response);
       
      if (response.status!==200) {
        const errorData = await response.data.error
        return  rejectWithValue(errorData);
      }
      const userData = await response.data.data;
      return userData;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);


export const fetchActiveUserbyAdmin:any = createAsyncThunk(
    'request/fetchActiveUserbyAdmin',
    async (params:{
        page?: number;
        size?: number;
        sort?: string[];
        filters?: any[];
      },{rejectWithValue}) => {
      try {
          const axiosConfig = {
          headers: {
            'Authorization' : 'Bearer '+getToken(),
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            // 'loggedInUser': getUserDetails()?.email,
              // 'loggedInUser': 'ananda.rao@indegene.com'
          },
        
          withCredentials: true
        };
        let paramStrings: string | null = composeParamsString(params);
        // Simulate an API call, replace with your actual API request
        const response = await axios.post(`user/employeeDetails/activeEmpDetails`,params,axiosConfig);
        console.log('user/employeeDetails/activeEmpDetails',response);
         
        if (response.status!==200) {
          const errorData = await response.data.error
          return  rejectWithValue(errorData);
        }
        const userData = await response.data.data;
        return userData;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const fetchInactiveUserbyAdmin:any = createAsyncThunk(
    'request/fetchInactiveUserbyAdmin',
    async (params:{
        page?: number;
        size?: number;
        sort?: string[];
        filters?: any[];
      },{rejectWithValue}) => {
      try {
          const axiosConfig = {
          headers: {
            'Authorization' : 'Bearer '+getToken(),
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            // 'loggedInUser': getUserDetails()?.email
              // 'loggedInUser': 'ananda.rao@indegene.com'
          },
        
          withCredentials: true
        };
        let paramStrings: string | null = composeParamsString(params);
        // Simulate an API call, replace with your actual API request
        const response = await axios.post(`user/employeeDetails/inactiveEmpDetails`,params,axiosConfig);
        console.log('user/employeeDetails/inactiveEmpDetails',response);
         
        if (response.status!==200) {
          const errorData = await response.data.error
          return  rejectWithValue(errorData);
        }
        const userData = await response.data.data;
        return userData;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const fetchAuditlogData:any = createAsyncThunk(
    'request/fetchAuditlogData',
    async (
      params:{
        employeeId: string;
        page?: number;
        size?: number;
        sort?: string[];
      },{rejectWithValue}) => {
      try {
          const axiosConfig = {
          headers: {
            'Authorization' : 'Bearer '+getToken(),
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            // 'loggedInUser': getUserDetails()?.email
            //   'loggedInUser': 'ananda.rao@indegene.com'
          },
        
          withCredentials: true
        };
        let paramStrings: string | null = composeParamsString(params);
        // Simulate an API call, replace with your actual API request
        const response = await axios.get(`user/employeeAuditLog/auditEmployeeDetails?employeeId=${params.employeeId}&${paramStrings}`,axiosConfig);
        console.log('user/employeeAuditLog/auditEmployeeDetails',response);
           
        if (response.status!==200) {
          const errorData = await response.data.error
          return  rejectWithValue(errorData);
        }
        const userData = await response.data.data;
        return userData;
      } catch (error: any) {
          
        return rejectWithValue(error.message);
      }
    }
  );

export const approveRejectByAdmin:any = createAsyncThunk(
    'user/request/approveRejectByAdmin',
    async (values:any,{ rejectWithValue }) => {
      try {
          const axiosConfig = {
          headers: {
            'Authorization' : 'Bearer '+getToken(),
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            // 'loggedInUser': getUserDetails()?.email
            // 'loggedInUser': 'saikiran.varala@indegene.com'
          },
          withCredentials: true
        };
        // Simulate an API call, replace with your actual API request
        const response = await axios.post(`user/request/approveRequest`,values,axiosConfig);
        console.log('user/request/approveRequest',response);
        if (response.data.status!=="OK") {
          const errorData = await response.data.error
          return rejectWithValue(errorData);
        }
        const userData = await response.data.data;
        return userData;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const revokeByAdmin:any = createAsyncThunk(
    'user/request/revokeByAdmin',
    async (values:any,{ rejectWithValue }) => {
      try {
          const axiosConfig = {
          headers: {
            'Authorization' : 'Bearer '+getToken(),
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json',
            // 'loggedInUser': getUserDetails()?.email
            //'loggedInUser': 'saikiran.varala@indegene.com'
          },
          withCredentials: true
        };
        // Simulate an API call, replace with your actual API request
        const response = await axios.post(`user/request/adminRevoke`,values,axiosConfig);
          
        console.log('user/request/adminRevoke',response);

        if (response.data.status!=='OK') {
          const errorData = await response.data.error
          return rejectWithValue(errorData);
        }
        const userData = await response.data.data;
        return userData;
      } catch (error: any) {
        return rejectWithValue(error.message);
      }
    }
  );

const UserDashboardSlice:any = createSlice({
  name: 'userDashboard',
  initialState,
  reducers: {
    // setSuccessFactorUserData: (state, action: PayloadAction<EmployeeResponse['data']>) => {
    //   state.data = action.payload;
    //   state.loading = false;
    //   state.error = null;
    // },
    fetchPendingRequestByAdmin_Request: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchPendingRequestByAdmin_Success: (state, action: PayloadAction<EmployeeResponse['pendingUserData']>) => {
         
      state.pendingUserData = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchPendingRequestByAdmin_Failure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingRequestbyAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendingRequestbyAdmin.fulfilled, (state, action) => {
         
        state.pendingUserData = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchPendingRequestbyAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(approveRejectByAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveRejectByAdmin.fulfilled, (state, action) => {
        // state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(approveRejectByAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchActiveUserbyAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActiveUserbyAdmin.fulfilled, (state, action) => {
         
        state.activeUserList = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchActiveUserbyAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(revokeByAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(revokeByAdmin.fulfilled, (state, action) => {
        // state.requestResponse = action.payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(revokeByAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchInactiveUserbyAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInactiveUserbyAdmin.fulfilled, (state, action) => {
         
        state.inactiveUserList = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchInactiveUserbyAdmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchAuditlogData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAuditlogData.fulfilled, (state, action) => {
         
        state.auditloglist = action.payload?.content;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchAuditlogData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  }
});

export const {fetchPendingRequestByAdmin_Request, fetchPendingRequestByAdmin_Success, fetchPendingRequestByAdmin_Failure } = UserDashboardSlice.actions;

export default UserDashboardSlice.reducer;